import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { FiCheck, FiCircle, FiCheckCircle } from "react-icons/fi";
import "./SubtasksList.css";

const SubtasksList = ({ task, onToggle, canToggle }) => {
  const completedCount = task.subtasks?.filter((s) => s.completed).length || 0;
  const totalCount = task.subtasks?.length || 0;
  const progress = totalCount > 0 ? Math.round((completedCount / totalCount) * 100) : 0;

  const formatTime = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toLocaleString("en-US", {
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  if (!task.subtasks || task.subtasks.length === 0) {
    return (
      <div className="rsl-empty">
        <div className="rsl-empty-icon">
          <FiCheckCircle size={32} />
        </div>
        <p>No subtasks added</p>
        <span>Break down this task into smaller steps</span>
      </div>
    );
  }

  return (
    <div className="rsl-container">
      {/* Progress Header */}
      <div className="rsl-header">
        <div className="rsl-stats">
          <span className="rsl-count">{completedCount} of {totalCount} completed</span>
          <span className="rsl-percentage">{progress}%</span>
        </div>
        <div className="rsl-progress-bar">
          <motion.div
            className="rsl-progress-fill"
            initial={{ width: 0 }}
            animate={{ width: `${progress}%` }}
            transition={{ duration: 0.5 }}
          />
        </div>
      </div>

      {/* Subtasks List */}
      <div className="rsl-list">
        <AnimatePresence>
          {task.subtasks.map((subtask, index) => (
            <motion.div
              key={subtask._id}
              className={`rsl-item ${subtask.completed ? "rsl-item--completed" : ""}`}
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, x: -20 }}
              transition={{ delay: index * 0.05 }}
            >
              <button
                className={`rsl-checkbox ${subtask.completed ? "rsl-checkbox--checked" : ""}`}
                onClick={() => canToggle && onToggle(subtask._id)}
                disabled={!canToggle}
              >
                {subtask.completed ? (
                  <FiCheck size={14} />
                ) : (
                  <FiCircle size={14} />
                )}
              </button>

              <div className="rsl-content">
                <span className="rsl-title">{subtask.title}</span>
                {subtask.completed && subtask.completedAt && (
                  <span className="rsl-meta">
                    Completed {formatTime(subtask.completedAt)}
                    {subtask.completedBy && ` by ${subtask.completedBy.name}`}
                  </span>
                )}
              </div>
            </motion.div>
          ))}
        </AnimatePresence>
      </div>
    </div>
  );
};

export default SubtasksList;
